import React from "react";
import PurchaseSideBar from "../../components/purchaseregister/PurchaseSideBar";
import commoncss from "../../css/common.module.css";

export default function PurchaseDashboard() {
  return (
    <>
      <div style={{ display: "flex" }}>
        <PurchaseSideBar activeTab={"Dashboard"} />
        <div className={`${commoncss.widthScrHidden} px-3 py-2`}>
          <h2>Dashboard</h2>
        </div>
      </div>
    </>
  );
}
